<bb-badge-ui
  text="paid in full"
  color="success"
  [abbr]="false"
  [circle]="false"
></bb-badge-ui>
